export function canUseEntityGlLayer(
  hostCanvas: HTMLCanvasElement,
  sharedContext: boolean,
): boolean {
  if (sharedContext) return true;
  const host = hostCanvas.getContext("2d");
  if (host === null || host === undefined) return false;
  return host.getContextAttributes?.().alpha !== false;
}
